export default __webpack_public_path__ + "static/media/producto.3fe6b033.jpg";